// import React, { useState, useEffect } from "react";
// import {
//   collection,
//   getDocs,
//   doc,
//   updateDoc,
//   deleteDoc,
// } from "firebase/firestore";
// import { db } from "../../firebase";
// import Swal from "sweetalert2";
// import css from "./videoReviews.module.css"; // Додано CSS для стилізації

// const VideoReviews = () => {
//   const [videos, setVideos] = useState([]);
//   const [editingVideo, setEditingVideo] = useState(null);
//   const [updatedData, setUpdatedData] = useState({});
//   const [books, setBooks] = useState([]);
//   const [ageCategories, setAgeCategories] = useState([]);

//   useEffect(() => {
//     fetchVideos();
//     fetchBooks();
//     fetchAgeCategories();
//   }, []);

//   const fetchVideos = async () => {
//     try {
//       const videoCollection = await getDocs(collection(db, "videoV"));
//       const videoList = videoCollection.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setVideos(videoList);
//     } catch (error) {
//       console.error("❌ Помилка отримання відео:", error);
//     }
//   };

//   const fetchBooks = async () => {
//     try {
//       const booksCollection = await getDocs(collection(db, "product"));
//       const booksList = booksCollection.docs.map((doc) => ({
//         uid: doc.id,
//         ...doc.data(),
//       }));
//       setBooks(booksList);
//     } catch (error) {
//       console.error("❌ Помилка отримання книг:", error);
//     }
//   };

//   const fetchAgeCategories = async () => {
//     try {
//       const querySnapshot = await getDocs(collection(db, "filters"));
//       const filtersData = querySnapshot.docs.map((doc) => doc.data());

//       const ageFilter = filtersData.find(
//         (filter) => filter.transliter === "yearGroup"
//       );

//       if (ageFilter) {
//         setAgeCategories(ageFilter.list);
//       }
//     } catch (error) {
//       console.error("❌ Помилка отримання вікових груп:", error);
//     }
//   };

//   const handleEdit = (video) => {
//     setEditingVideo(video.id);
//     setUpdatedData({ ...video, ageCategories: video.ageCategories || [] });
//   };

//   const handleUpdate = async () => {
//     if (!updatedData.videoName || !updatedData.videoDesc) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Назва відео та опис є обов'язковими!",
//       });
//       return;
//     }

//     try {
//       const videoDoc = doc(db, "videoV", editingVideo);
//       await updateDoc(videoDoc, updatedData);
//       Swal.fire({
//         icon: "success",
//         title: "Успішно",
//         text: "Відео оновлено!",
//       });
//       setEditingVideo(null);
//       fetchVideos();
//     } catch (error) {
//       console.error("❌ Помилка оновлення відео:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Не вдалося оновити відео.",
//       });
//     }
//   };

//   const handleDelete = async (videoId) => {
//     const result = await Swal.fire({
//       title: "Ви впевнені?",
//       text: "Це відео буде видалене назавжди!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Так, видалити!",
//       cancelButtonText: "Скасувати",
//     });

//     if (result.isConfirmed) {
//       try {
//         await deleteDoc(doc(db, "videoV", videoId));
//         Swal.fire("Видалено!", "Відео успішно видалене.", "success");
//         fetchVideos();
//       } catch (error) {
//         console.error("❌ Помилка видалення відео:", error);
//         Swal.fire("Помилка!", "Не вдалося видалити відео.", "error");
//       }
//     }
//   };

//   const handleAddAgeCategory = () => {
//     setUpdatedData((prev) => ({
//       ...prev,
//       ageCategories: [...prev.ageCategories, ""],
//     }));
//   };

//   const handleAgeChange = (index, value) => {
//     const updatedAges = [...updatedData.ageCategories];
//     updatedAges[index] = value;
//     setUpdatedData({ ...updatedData, ageCategories: updatedAges });
//   };

//   const handleRemoveAgeCategory = (index) => {
//     const updatedAges = updatedData.ageCategories.filter((_, i) => i !== index);
//     setUpdatedData({ ...updatedData, ageCategories: updatedAges });
//   };

//   return (
//     <div className="video-container">
//       <h2>📹 Відео Відгуки</h2>
//       {videos.length === 0 ? (
//         <p>⏳ Завантаження відео...</p>
//       ) : (
//         <div>
//           {videos.map((video) => (
//             <div key={video.id} className="video-card">
//               {editingVideo === video.id ? (
//                 <div className="edit-form">
//                   <label>Назва відео:</label>
//                   <input
//                     type="text"
//                     value={updatedData.videoName}
//                     onChange={(e) =>
//                       setUpdatedData({
//                         ...updatedData,
//                         videoName: e.target.value,
//                       })
//                     }
//                   />

//                   <label>Опис відео:</label>
//                   <textarea
//                     value={updatedData.videoDesc}
//                     onChange={(e) =>
//                       setUpdatedData({
//                         ...updatedData,
//                         videoDesc: e.target.value,
//                       })
//                     }
//                   />

//                   <label>Вікові категорії:</label>
//                   {updatedData.ageCategories.map((age, index) => (
//                     <div key={index} className="age-category">
//                       <select
//                         value={age}
//                         onChange={(e) => handleAgeChange(index, e.target.value)}
//                       >
//                         <option value="">Оберіть категорію</option>
//                         {ageCategories.map((category, idx) => (
//                           <option key={idx} value={category}>
//                             {category}
//                           </option>
//                         ))}
//                       </select>
//                       <button onClick={() => handleRemoveAgeCategory(index)}>
//                         🗑
//                       </button>
//                     </div>
//                   ))}
//                   <button onClick={handleAddAgeCategory}>
//                     ➕ Додати категорію
//                   </button>

//                   <button onClick={handleUpdate}>💾 Зберегти</button>
//                   <button onClick={() => setEditingVideo(null)}>
//                     ❌ Скасувати
//                   </button>
//                 </div>
//               ) : (
//                 <div>
//                   <h3>{video.videoName}</h3>
//                   <p>{video.videoDesc}</p>
//                   <p>📚 Книга: {video.bookName || "Не вказано"}</p>
//                   <p>🎥 ID Відео: {video.videoId}</p>
//                   <p>
//                     🗂 Вікові категорії:{" "}
//                     {video.ageCategories?.join(", ") || "Не вказано"}
//                   </p>

//                   {video.videoId && (
//                     <iframe
//                       width="300"
//                       height="200"
//                       src={`https://www.youtube.com/embed/${video.videoId}`}
//                       title="YouTube video"
//                       frameBorder="0"
//                       allowFullScreen
//                     ></iframe>
//                   )}

//                   <div>
//                     <button onClick={() => handleEdit(video)}>
//                       ✏️ Редагувати
//                     </button>
//                     <button onClick={() => handleDelete(video.id)}>
//                       🗑 Видалити
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default VideoReviews;
import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import css from "./videoReviews.module.css";

const VideoReviews = () => {
  const [videos, setVideos] = useState([]);
  const [editingVideo, setEditingVideo] = useState(null);
  const [updatedData, setUpdatedData] = useState({});
  const [books, setBooks] = useState([]);
  const [ageCategories, setAgeCategories] = useState([]);

  useEffect(() => {
    fetchVideos();
    fetchBooks();
    fetchAgeCategories();
  }, []);

  const fetchVideos = async () => {
    try {
      const videoCollection = await getDocs(collection(db, "videoV"));
      const videoList = videoCollection.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setVideos(videoList);
    } catch (error) {
      console.error("❌ Помилка отримання відео:", error);
    }
  };

  const fetchBooks = async () => {
    try {
      const booksCollection = await getDocs(collection(db, "product"));
      const booksList = booksCollection.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));
      setBooks(booksList);
    } catch (error) {
      console.error("❌ Помилка отримання книг:", error);
    }
  };

  const fetchAgeCategories = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "filters"));
      const filtersData = querySnapshot.docs.map((doc) => doc.data());

      const ageFilter = filtersData.find(
        (filter) => filter.transliter === "yearGroup"
      );

      if (ageFilter) {
        setAgeCategories(ageFilter.list);
      }
    } catch (error) {
      console.error("❌ Помилка отримання вікових груп:", error);
    }
  };

  const handleEdit = (video) => {
    setEditingVideo(video.id);
    setUpdatedData({ ...video, ageCategories: video.ageCategories || [] });
  };

  const handleUpdate = async () => {
    if (!updatedData.videoName || !updatedData.videoDesc) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Назва відео та опис є обов'язковими!",
      });
      return;
    }

    try {
      const videoDoc = doc(db, "videoV", editingVideo);
      await updateDoc(videoDoc, updatedData);
      Swal.fire({
        icon: "success",
        title: "Успішно",
        text: "Відео оновлено!",
      });
      setEditingVideo(null);
      fetchVideos();
    } catch (error) {
      console.error("❌ Помилка оновлення відео:", error);
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Не вдалося оновити відео.",
      });
    }
  };

  const handleDelete = async (videoId) => {
    const result = await Swal.fire({
      title: "Ви впевнені?",
      text: "Це відео буде видалене назавжди!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Так, видалити!",
      cancelButtonText: "Скасувати",
    });

    if (result.isConfirmed) {
      try {
        await deleteDoc(doc(db, "videoV", videoId));
        Swal.fire("Видалено!", "Відео успішно видалене.", "success");
        fetchVideos();
      } catch (error) {
        console.error("❌ Помилка видалення відео:", error);
        Swal.fire("Помилка!", "Не вдалося видалити відео.", "error");
      }
    }
  };

  const handleAddAgeCategory = () => {
    setUpdatedData((prev) => ({
      ...prev,
      ageCategories: [...prev.ageCategories, ""],
    }));
  };

  const handleAgeChange = (index, value) => {
    const updatedAges = [...updatedData.ageCategories];
    updatedAges[index] = value;
    setUpdatedData({ ...updatedData, ageCategories: updatedAges });
  };

  const handleRemoveAgeCategory = (index) => {
    const updatedAges = updatedData.ageCategories.filter((_, i) => i !== index);
    setUpdatedData({ ...updatedData, ageCategories: updatedAges });
  };

  return (
    <div className="video-container">
      <h2>📹 Відео Відгуки</h2>
      {videos.length === 0 ? (
        <p>⏳ Завантаження відео...</p>
      ) : (
        <div>
          {videos.map((video) => (
            <div key={video.id} className="video-card">
              {editingVideo === video.id ? (
                <div className="edit-form">
                  <label>Назва відео:</label>
                  <input
                    type="text"
                    value={updatedData.videoName}
                    onChange={(e) =>
                      setUpdatedData({
                        ...updatedData,
                        videoName: e.target.value,
                      })
                    }
                  />

                  <label>Опис відео:</label>
                  <textarea
                    value={updatedData.videoDesc}
                    onChange={(e) =>
                      setUpdatedData({
                        ...updatedData,
                        videoDesc: e.target.value,
                      })
                    }
                  />

                  <label>ID Відео (YouTube):</label>
                  <input
                    type="text"
                    value={updatedData.videoId}
                    onChange={(e) =>
                      setUpdatedData({
                        ...updatedData,
                        videoId: e.target.value,
                      })
                    }
                  />

                  <label>Вікові категорії:</label>
                  {updatedData.ageCategories.map((age, index) => (
                    <div key={index} className="age-category">
                      <select
                        value={age}
                        onChange={(e) => handleAgeChange(index, e.target.value)}
                      >
                        <option value="">Оберіть категорію</option>
                        {ageCategories.map((category, idx) => (
                          <option key={idx} value={category}>
                            {category}
                          </option>
                        ))}
                      </select>
                      <button onClick={() => handleRemoveAgeCategory(index)}>
                        🗑
                      </button>
                    </div>
                  ))}
                  <button onClick={handleAddAgeCategory}>
                    ➕ Додати категорію
                  </button>

                  <button onClick={handleUpdate}>💾 Зберегти</button>
                  <button onClick={() => setEditingVideo(null)}>
                    ❌ Скасувати
                  </button>
                </div>
              ) : (
                <div>
                  <h3>{video.videoName}</h3>
                  <p>{video.videoDesc}</p>
                  <p>📚 Книга: {video.bookName || "Не вказано"}</p>
                  <p>🎥 ID Відео: {video.videoId}</p>
                  <p>
                    🗂 Вікові категорії:{" "}
                    {video.ageCategories?.join(", ") || "Не вказано"}
                  </p>

                  {video.videoId && (
                    <iframe
                      width="300"
                      height="200"
                      src={`https://www.youtube.com/embed/${video.videoId}`}
                      title="YouTube video"
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  )}

                  <div>
                    <button onClick={() => handleEdit(video)}>
                      ✏️ Редагувати
                    </button>
                    <button onClick={() => handleDelete(video.id)}>
                      🗑 Видалити
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VideoReviews;
